<template>
  <div
    :class="[
      'toggle-arrow-icon',
      {
        'toggle-arrow-icon--expanded': isExpanded
      }
    ]"
  ></div>
</template>

<script>
export default {
  props: {
    isExpanded: Boolean
  }
}
</script>

<style lang="scss" scoped>
.toggle-arrow-icon {
  transform: rotate(0deg);
  top: 3px;
  left: 5px;
  width: 15px;
  height: 15px;
  display: inline-block;
  position: relative;
  transition: all 0.25s ease;
  line-height: 0;

  &:after,
  &:before {
    background-color: transparent;
    width: 1px;
    height: 6px;
    display: inline-block;
    position: absolute;
    border-bottom: 9px solid $blue-900;
    top: 0;
    left: 0;
    content: '';
    transition: all 0.25s ease;
    box-sizing: border-box;
  }

  &:before {
    transform: rotate(135deg);
    left: 1px;
  }

  &:after {
    transform: rotate(-135deg);
    left: 7px;
  }

  &--expanded {
    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}
</style>
